import React from 'react';
import RetailerLayout from '../components/RetailerLayout';

/**
 * DashboardPage V2 - 100% Dynamique
 * 
 * ✅ Utilise RetailerLayout qui gère tout via PageBlocksRenderer
 * ✅ AUCUN contenu hardcodé
 * ✅ Tous les blocs viennent de la base de données
 * ✅ Configuration admin requise pour afficher du contenu
 * 
 * Pour ajouter du contenu à cette page :
 * 1. Aller dans Admin → Pages
 * 2. Trouver la page avec slug "/dashboard"
 * 3. Ajouter des blocs (bannières, produits, texte, etc.)
 * 4. Configurer les blocs globaux (Header, Menu, Footer)
 */
const DashboardPage = () => {
  // La page utilise automatiquement le slug actuel ("/dashboard")
  // RetailerLayout charge et affiche tous les blocs associés
  return <RetailerLayout />;
};

export default DashboardPage;